<header>
  <div class="wrap">
    <h2 class="title mb-4">{{ 'popins.decking-boards-class-info.title' | translate }}</h2>

    <div class="modal-container shadow" *ngFor="let class of classesInformations">
      <h3 class="title" *ngIf="currentLang === 'fr'">{{ class.titleFr }}</h3>
      <h3 class="title" *ngIf="currentLang === 'en'">{{ class.titleEn }}</h3>
      <p class="subtitle" *ngIf="currentLang === 'fr'">{{ class.subTitleFr }}</p>
      <p class="subtitle" *ngIf="currentLang === 'en'">{{ class.subTitleEn }}</p>
      <p class="text" *ngIf="currentLang === 'fr'">{{ class.descriptionFr }}</p>
      <p class="text" *ngIf="currentLang === 'en'">{{ class.descriptionEn }}</p>
    </div>

    <div class="header-actions">
      <button class="close" (click)="modalService.close()" title="{{ 'generic.close' | translate }}">
        <span class="icon-view-close" aria-hidden="true">
          <svg>
            <use xlink:href="assets/img/icons.svg#icon-view-close"></use>
          </svg>
        </span>
        <span>{{ 'generic.close' | translate }}</span>
      </button>
    </div>
  </div>
</header>
<div class="main">
  <footer class="popin-footer">
    <ng-casto-btn
      class="blue"
      [label]="'popins.decking-boards-class-info.confirm' | translate"
      (click)="modalService.close()"></ng-casto-btn>
  </footer>
</div>
